import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {ExpensesCategory} from './expenses-category.entity';
import {ExpensesCategoryDTO} from './dto/expenses-category.dto';
import {ExpensesCategoryAdapter} from './dto/expenses-category.adapter';
import { ExpensesCategoryResponse, AllExpensesCategoryResponse } from '@gtpl/shared-models/hrms';
import { ExpensesCategoryRequest } from './dto/expenses-category.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class ExpensesCategoryService {
    constructor(
      private logService:LogsService,

        @InjectRepository(ExpensesCategory)
        private expensesCategoryRepository: Repository<ExpensesCategory>,
        private Adapter: ExpensesCategoryAdapter,
    ){}
    /**
     * get expensesCategory details
     * @param expensesCategory 
     */
    // @LogActions({isAsync: true})
    async getExpensesCategoryDetailsWithoutRelations(expensesCategory: string): Promise<ExpensesCategory> {
        // tslint:disable-next-line: typedef
        const expensesCategoryResponse = await this.expensesCategoryRepository.findOne({
          where: {expensesCategory: Raw(alias => `expenses_category = '${expensesCategory}'`)},
        });
        if (expensesCategoryResponse) {
          return expensesCategoryResponse;
        } else {
          return null;
        }
      }

      async createExpensesCategory(expensesCategoryDto: ExpensesCategoryDTO, isUpdate: boolean): Promise<ExpensesCategoryResponse> {
        // console.log(statesDto);
        try {
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          if (!isUpdate) {
            const expensesCategoryEntity = await this.getExpensesCategoryDetailsWithoutRelations(expensesCategoryDto.expensesCategory);
            if (expensesCategoryEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'Expenses Category already exists');
            }
          }
          else{
            const expensesCategoryEntity = await this.getExpensesCategoryDetailsWithoutRelations(expensesCategoryDto.expensesCategory);
            if (expensesCategoryEntity) {
              if(expensesCategoryEntity.expensesCategoryId!=expensesCategoryDto.expensesCategoryId) {
                throw new ErrorResponse(11104, 'Expenses Category already exists');      
            }
              //return new InformationMessageError(11104, "State already exists");
            }
          }
          const convertedExpensesCategoryEntity: ExpensesCategory = this.Adapter.convertDtoToEntity(expensesCategoryDto,isUpdate);
          const savedExpensesCategoryEntity: ExpensesCategory = await this.expensesCategoryRepository.save(
            convertedExpensesCategoryEntity
          );
          const savedExpensesCategoryDto: ExpensesCategoryDTO = this.Adapter.convertEntityToDto(convertedExpensesCategoryEntity);
            // console.log(savedStateDto);
          if (savedExpensesCategoryDto) {
            // generating resposnse
            const response = new ExpensesCategoryResponse(true,1,isUpdate? 'Expenses Category Updated Successfully': 'Expenses CategoryCreated Successfully')
            const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'ExpensesCategory', savedExpensesCategoryDto.expensesCategoryId, true, '',savedExpensesCategoryDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'Expenses Category saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  

      async getAllExpensesCategories(): Promise<AllExpensesCategoryResponse> {
        // const page: number = 1;
        
        try {
          const ExpensesCategoryDtos: ExpensesCategoryDTO[] = [];
          //retrieves all companies
          const ExpensesCategoryEntities: ExpensesCategory[] = await this.expensesCategoryRepository.find({order :{'createdAt':'DESC'}});
          //console.log(statesEntities);
          if (ExpensesCategoryEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            ExpensesCategoryEntities.forEach(ExpensesCategoryEntity => {
              const convertedExpensesCategoryDto: ExpensesCategoryDTO = this.Adapter.convertEntityToDto(
                ExpensesCategoryEntity
              );
              ExpensesCategoryDtos.push(convertedExpensesCategoryDto);
            });
            const response = new AllExpensesCategoryResponse(true,1,'Expenses Category retrieved successfully',ExpensesCategoryDtos);
            //generated response
            const newLogDto = new LogsDto(1,'view', 'ExpensesCategory', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveExpensesCategories(): Promise<AllExpensesCategoryResponse> {
        // const page: number = 1;
        try {
            const expensesCategoryDto: ExpensesCategoryDTO[] = [];
            //retrieves all expenses Categories
            const ExpensesCategoryEntities: ExpensesCategory[] = await this.expensesCategoryRepository.find({ order: { 'expensesCategory': 'ASC' },where:{isActive:true},
           });
         console.log(ExpensesCategoryEntities)
            if (ExpensesCategoryEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                ExpensesCategoryEntities.forEach(expensesCategoryEntity => {
                    const convertedexpensesCategoryDto: ExpensesCategoryDTO = this.Adapter.convertEntityToDto(
                      expensesCategoryEntity
                      
                    );
                    expensesCategoryDto.push(convertedexpensesCategoryDto);
                });
                const response = new AllExpensesCategoryResponse(true, 11108, "ExpensesCategory retrieved successfully", expensesCategoryDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); expensesCategoryDto
            }
        } catch (err) {
            throw err;
        }
    }
      async activateOrDeactivateExpensesCategory(expensesCategoryReq: ExpensesCategoryRequest): Promise<ExpensesCategoryResponse> {
        try {
            const expensesCategoryExists = await this.getExpensesCategoryById(expensesCategoryReq.expensesCategoryId);
            if (expensesCategoryExists) {
                if (expensesCategoryReq.versionFlag !== expensesCategoryExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Expenses category information.Refresh and try again');
                } else {
                    
                        const expensesCategoryStatus =  await this.expensesCategoryRepository.update(
                            { expensesCategoryId: expensesCategoryReq.expensesCategoryId },
                            { isActive: expensesCategoryReq.isActive,updatedUser: expensesCategoryReq.updatedUser });
                       
                        if (expensesCategoryExists.isActive) {
                            if (expensesCategoryStatus.affected) {
                                const expensesCategoryResponse: ExpensesCategoryResponse = new ExpensesCategoryResponse(true, 10115, 'ExpensesCategory is de-activated successfully');
                                return expensesCategoryResponse;
                            } else {
                                throw new ErrorResponse(10111, 'ExpensesCategory is already deactivated');
                            }
                        } else {
                            if (expensesCategoryStatus.affected) {
                                const expensesCategoryResponse: ExpensesCategoryResponse = new ExpensesCategoryResponse(true, 10114, 'ExpensesCategory is activated successfully');
                                return expensesCategoryResponse;
                            } else {
                                throw new ErrorResponse(10112, 'ExpensesCategory is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
      async getActiveExpensesCategoryById(expensesCategoryReq: ExpensesCategoryRequest): Promise<ExpensesCategoryResponse> {
        try {
          //retrieves all companies
          const ExpensesCategoryEntities: ExpensesCategory = await this.expensesCategoryRepository.findOne({
              where:{expensesCategoryId:expensesCategoryReq.expensesCategoryId}
              });
              
              const expensesCategoryData: ExpensesCategoryDTO = this.Adapter.convertEntityToDto(ExpensesCategoryEntities);
              if (expensesCategoryData) {
                  const response = new ExpensesCategoryResponse(true, 11101 , 'ExpensesCategory retrived Successfully',expensesCategoryData);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          throw err;
      }
    }

    async getExpensesCategoryById(expensesCategoryId: number): Promise<ExpensesCategory> {
        //  console.log(employeeId);
            const Response = await this.expensesCategoryRepository.findOne({
            where: {expensesCategoryId: expensesCategoryId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}
